(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  const fSzCartStart = () => {
    const oCart = document.querySelector('#cart-icon-bubble');
    const oHeader = document.querySelector('.section-header');

    if (!oCart || !oHeader) return;

    const oIconTemplate = oCart.querySelector('.szCartIcon svg').cloneNode(true);
    const oPlaceholder = document.createElement('span');
    const isCartPage = oCart.dataset.cartPage === 'true';
    const isInitiallyHidden = oCart.hidden;
    let vCount = 0;
    let vFrame = 0;
    let vAnimationTimer = 0;
    let isMenuVisibleLast = null;
    let vTop = 0;

    oPlaceholder.className = 'header__icon header__icon--cart szCartPlaceholder';
    oPlaceholder.setAttribute('aria-hidden', 'true');
    oCart.before(oPlaceholder);
    oCart.hidden = false;
    vTop = oCart.getBoundingClientRect().top;
    oCart.hidden = isInitiallyHidden;

    const fCartCount = () => {
      const oBubble = oCart.querySelector('.cart-count-bubble');
      const oVisibleCount = oBubble ? oBubble.querySelector('[aria-hidden="true"]') : null;
      const vText = oVisibleCount ? oVisibleCount.textContent : oBubble ? oBubble.textContent : '';
      const aMatch = vText.match(/\d+/);

      return aMatch ? Number(aMatch[0]) : 0;
    };

    const fAnimate = () => {
      window.clearTimeout(vAnimationTimer);
      oCart.classList.remove('szCartPulse');
      void oCart.offsetWidth;
      oCart.classList.add('szCartPulse');
      vAnimationTimer = window.setTimeout(() => {
        oCart.classList.remove('szCartPulse');
      }, 600);
    };

    const fSetPosition = () => {
      const oPosition = oCart.classList.contains('szCartSticky') ? oPlaceholder : oCart;
      const oPositionRect = oPosition.getBoundingClientRect();

      if (oHeader.getBoundingClientRect().bottom > 0 && oPositionRect.top >= 0) {
        vTop = oPositionRect.top;
      }
      oCart.style.setProperty('--sz-cart-top', `${vTop}px`);
      oCart.style.setProperty('--sz-cart-left', `${oPositionRect.left}px`);
    };

    const fSetSticky = (isSticky) => {
      const isCurrent = oCart.classList.contains('szCartSticky');

      if (isSticky === isCurrent) {
        return;
      }
      if (isSticky) {
        fSetPosition();
        oPlaceholder.classList.add('szCartPlaceholderVisible');
        document.body.append(oCart);
        oCart.classList.add('szCartSticky');
        return;
      }
      oPlaceholder.after(oCart);
      oPlaceholder.classList.remove('szCartPlaceholderVisible');
      oCart.classList.remove('szCartSticky');
      oCart.style.removeProperty('--sz-cart-top');
      oCart.style.removeProperty('--sz-cart-left');
    };

    const fSync = () => {
      const oIconWrapper = oCart.querySelector('.svg-wrapper');
      if (oIconWrapper && !oIconWrapper.classList.contains('szCartIcon')) {
        oIconWrapper.classList.add('szCartIcon');
        oIconWrapper.replaceChildren(oIconTemplate.cloneNode(true));
      }
      const vNewCount = fCartCount();
      const isHidden = vNewCount === 0 || isCartPage;
      const isMenuVisible = !oHeader.classList.contains('shopify-section-header-hidden');
      const isMenuChanged = isMenuVisibleLast !== null && isMenuVisibleLast !== isMenuVisible;

      if (oCart.hidden !== isHidden) oCart.hidden = isHidden;
      fSetSticky(!isHidden);
      oCart.classList.toggle('szCartMenuVisible', isMenuVisible);
      if (!isHidden && (vNewCount > vCount || isMenuChanged)) fAnimate();
      vCount = vNewCount;
      isMenuVisibleLast = isMenuVisible;
    };

    const fQueueSync = () => {
      window.cancelAnimationFrame(vFrame);
      vFrame = window.requestAnimationFrame(fSync);
    };

    vCount = fCartCount();
    new MutationObserver(fQueueSync).observe(oCart, {
      childList: true,
      subtree: true,
    });
    new MutationObserver(fQueueSync).observe(oHeader, {
      attributes: true,
      attributeFilter: ['class'],
    });
    window.addEventListener('resize', () => {
      if (oCart.classList.contains('szCartSticky')) fSetPosition();
      fQueueSync();
    });
    fSync();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fSzCartStart, { once: true });
  } else {
    fSzCartStart();
  }

  } catch(e) { console.error(e); }
})();
})();
